import { ManagedUserGroup, SearchQueryOrderDirection } from "types/generated";

import { IdpGroupFilterItemKeys } from "../constants";

export const sortGroups = (
  groups: Array<ManagedUserGroup>,
  sortKey?: IdpGroupFilterItemKeys,
  sortDirection?: SearchQueryOrderDirection
): Array<ManagedUserGroup> => {
  // If no sort key or direction is provided, or if sort key is invalid, return unsorted copy
  if (!sortKey || !sortDirection || !Object.values(IdpGroupFilterItemKeys).includes(sortKey)) {
    return [...groups];
  }

  const sortedGroups = [...groups];

  return sortedGroups.sort((a, b) => {
    let aValue, bValue;

    switch (sortKey) {
      case IdpGroupFilterItemKeys.GroupId:
        aValue = a.groupName;
        bValue = b.groupName;
        break;
      case IdpGroupFilterItemKeys.Spaces:
        aValue = a.spaceCount;
        bValue = b.spaceCount;
        break;
      case IdpGroupFilterItemKeys.Users:
        aValue = a.memberCount;
        bValue = b.memberCount;
        break;
      case IdpGroupFilterItemKeys.LastLogin:
        aValue = a.lastLoginTime;
        bValue = b.lastLoginTime;
        break;
      case IdpGroupFilterItemKeys.IdentityProvider:
        aValue = a.identityProvider;
        bValue = b.identityProvider;
        break;
      case IdpGroupFilterItemKeys.Status:
        aValue = a.status;
        bValue = b.status;
        break;
      default:
        // This case should never be reached due to the validation at the beginning
        // But just in case, return a copy of the unsorted array
        return 0;
    }

    // null values should always come last
    if (aValue === null && bValue === null) {
      return 0; // Both null, consider equal
    }
    if (aValue === null) {
      return 1; // a is null, should be placed after b
    }
    if (bValue === null) {
      return -1; // b is null, should be placed after a
    }

    // Sort based on direction for other fields
    if (sortDirection === SearchQueryOrderDirection.Asc) {
      if (typeof aValue === "string" && typeof bValue === "string") {
        return aValue.localeCompare(bValue);
      }
      return aValue > bValue ? 1 : -1;
    } else {
      if (typeof aValue === "string" && typeof bValue === "string") {
        return bValue.localeCompare(aValue);
      }
      return bValue > aValue ? 1 : -1;
    }
  });
};
